import React from 'react'
import { func, string, oneOfType, node, bool } from 'prop-types'

import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  FormControl,
} from '@material-ui/core'

import FormHelperText from './Checkbox.style'

export default function Checkbox({
  label,
  name,
  reference,
  errorMessage,
  onChange,
  checked,
}) {
  return (
    <FormControl>
      <FormControlLabel
        control={
          <MuiCheckbox
            name={name}
            inputRef={reference}
            onChange={onChange}
            checked={checked}
          />
        }
        label={label}
        labelPlacement="end"
      />
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}

Checkbox.propTypes = {
  label: oneOfType([string, node]),
  name: string.isRequired,
  reference: func.isRequired,
  errorMessage: string,
  onChange: func,
  checked: bool,
}

Checkbox.defaultProps = {
  label: null,
  checked: undefined,
  errorMessage: '',
  onChange: () => {},
}
